import { LogManager } from 'aurelia-framework';
import { ConsoleAppender } from 'aurelia-logging-console';

class AppLogger {
  constructor(appConfiguration) {
    'inject';

    this.mainLoggerName = appConfiguration.get('appName');
    if (appConfiguration.get('loggingEnabled')) {
      LogManager.setLevel(appConfiguration.get('loggingLevel') || 'none');
      LogManager.addAppender(new ConsoleAppender());
    }
  }
  getLogger(name) {
    return LogManager.getLogger(name);
  }
  debug(...args) {
    return this._getMainLogger().debug(...args);
  }
  info(...args) {
    return this._getMainLogger().info(...args);
  }
  warn(...args) {
    return this._getMainLogger().warn(...args);
  }
  error(...args) {
    return this._getMainLogger().error(...args);
  }
  _getMainLogger() {
    return this.getLogger(this.mainLoggerName);
  }
}

export { AppLogger };
